import { Component, Input } from '@angular/core';

import { TableControlComponent } from '../table-control.component';
import { TableService          } from '../../../table.service';

@Component({
  styles: [ require('../table-control.component.scss') ],
  template: require('./table-text-control.component.html')
})
export class TableTextControlComponent extends TableControlComponent {
  declare maxlength: number;

  _max : number;
  _min : number;
  _type: string;

  @Input() set max ( _max : number | Function ) {
    this._max = _max instanceof Function ? _max(this.record) : _max;
  }

  @Input() set min ( _min : number | Function ) {
    this._min = _min instanceof Function ? _min(this.record) : _min;
  }

  @Input() set type (_type: string) {
    this._type = _type ?? 'text';
  }

  constructor (
    service: TableService
  ) {
    super(service);
  }

  handleFocus ( $event : FocusEvent ) : void {
    ( $event.target as HTMLInputElement ).select();

    this.focus.emit();
  }
}